import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { WorkExperienceType } from './work-experience-type.interface';
import { WorkExperienceTypeService } from './work-experience-type.service';

const service = new WorkExperienceTypeService();

export interface WorkExperienceTypeState {
   workExperienceTypes: Array<WorkExperienceType>;
}

const WorkExperienceTypeStore: Module<WorkExperienceTypeState, StoreState> = {
   namespaced: true,
   state: { workExperienceTypes: [] },
   getters: {
      workExperienceType: (state) => state.workExperienceTypes,
   },
   mutations: {
      SET_WORK_EXPERIENCE_TYPES(state, workExperienceTypes: Array<WorkExperienceType>) {
         state.workExperienceTypes = workExperienceTypes;
      },
   },
   actions: {
      async getWorkExperienceTypes(context) {
         const response = await service.getWorkExperienceTypes();
         context.commit('SET_WORK_EXPERIENCE_TYPES', response.data);
         return response;
      },
   },
};

export default WorkExperienceTypeStore;
